var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"support"},[_vm._v("开发者技术支持 如有问题请联系邮箱: mail.aotu.co")])
}
var staticRenderFns = []

export { render, staticRenderFns }